import React from 'react';
import { CustomerVerification } from '../components/verification/CustomerVerification';

const CustomerVerificationPage = () => {
  return <CustomerVerification />;
};

export default CustomerVerificationPage;
